export const UPDATE = 'socrates-online/bolton/UPDATE';
export const ISGOLD = 'socrates-online/bolton/ISGOLD';
export const GOTOREVIEW = 'socrates-online/bolton/GOTOREVIEW';

const initialState = {
  updateBolton: '',
  isGoldUpdated: false,
  isBoltOnUpdated: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE:
      return {
        ...state,
        updateBolton: action.updateBolton,
      };
    case ISGOLD:
      return {
        ...state,
        isGoldUpdated: action.isGoldUpdated,
      };
    case GOTOREVIEW:
      return {
        ...state,
        goToReview: action.goToReview,
      };
    default:
      return state;
  }
}
